import React, { FC } from 'react';
import { OpenChatButton } from '../OpenChatButton';
import { ActionsProps } from './props';
import './styles.scss';

export const Actions: FC<ActionsProps> = ({ onOpenChat, isUnread }) => {
  return (
    <div className="opening-applicant-card-actions">
      <div className="opening-applicant-card-actions__view-profile">View details</div>

      <OpenChatButton isUnread={isUnread} onOpenChat={onOpenChat} />
    </div>
  );
};
